module.exports = __webpack_public_path__ + "static/black-center@2x.ca543b5c.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/brand/black-center@2x.png
// module id = 155
// module chunks = 9